import comp from "./ArchivedYearGroupBanner";
export default comp;
